import React from 'react';
import Logo from './Logo';
import './common.css';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faYoutube,
  faFacebook,
  faInstagram,
  faTwitter
} from "@fortawesome/free-brands-svg-icons";
import {
  Container,
  Row,
  Col,
  NavLink
} from 'reactstrap';

export default function AppFooter() {
  return (
    <footer className="footer-app">
      <section>
        <Container>
          <Row className="pb-4 mx-2 mx-sm-0 justify-content-center">
            <Col xs="6" sm="3" className="d-flex justify-content-center mb-3 mb-sm-0">
              <NavLink
                id="button-youtube"
                className="footer-social-link"
                href="https://www.youtube.com/channel/UCX5w6KTXJAv219CrbmXb5_Q?sub_confirmation=1"
                title="Youtube"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faYoutube} />
              </NavLink>
              <NavLink
                id="button-facebook"
                className="footer-social-link"
                href="https://www.facebook.com/SJ.SocialMedia/"
                title="Facebook"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebook} />
              </NavLink>
              <NavLink
                id="button-instagram"
                className="footer-social-link"
                href="https://www.instagram.com/SJ.SocialMedia/"
                title="Instagram"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </NavLink>
              <NavLink
                id="button-twitter"
                className="footer-social-link"
                href="https://twitter.com/SJ_SocialMedia"
                title="Twitter"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faTwitter} />
              </NavLink>
            </Col>
          </Row>
        </Container>
      </section>
      <Container className="py-5">
        <Row>
          <Col xs="12" lg="4" className="d-flex flex-column justify-content-center align-items-lg-start align-items-center mb-4 mb-lg-0">
            <Logo size={56} className="mb-2" />
            <small className="footer-copyright">
              © 2011-2025 SJ Social Media
            </small>
          </Col>
          <Col xs="12" md="6" lg="4" className="mb-4 mb-lg-0">
            <div className="footer-office text-center text-lg-start">
              <h6 className="footer-office-title">
                Production office:
              </h6>
              <p className="footer-office-address mb-0">
                CC Unicentro<br />
                Cra 100 #5-169<br />
                Cali, VA 76001
              </p>
            </div>
          </Col>
          <Col xs="12" md="6" lg="4">
            <div className="footer-office text-center text-lg-start">
              <h6 className="footer-office-title">
                US office:
              </h6>
              <p className="footer-office-address mb-0">
                Security Building<br />
                117 NE 1st Ave<br />
                Miami, FL 33132
              </p>
            </div>
          </Col>
        </Row>
      </Container>
      <div className="footer-madeby">
        Made with <span className="footer-heart">❤</span> by SJ Social Media Team
      </div>
    </footer>
  );
}
